export const cacheKeys = {
  getSpecialization: 'getSpecialization',
  getSpecializations: 'getSpecializations',
  likeSpecialization: 'likeSpecialization',
  unlikeSpecialization: 'unlikeSpecialization',
  ignoreSpecialization: 'ignoreSpecialization',
};
